
import { LogLevel } from "@azure/msal-browser";

/**
 * Detect environment based on current URL:
 * - 'prod'  → https://newmy.muic.io/
 * - 'stg'   → https://newmy-dev.muic.io/
 * - 'local' → localhost:8000, 8001, 3000
 */
const getEnvironment = () => {
    const hostname = globalThis.location.hostname;
    const port = globalThis.location.port;

    if (hostname === 'newmy.muic.io') return 'prod';
    if (hostname === 'newmy-dev.muic.io') return 'stg';

    // localhost or 127.0.0.1 on known dev ports
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        if (['8000', '8001', '3000'].includes(port)) return 'local';
        return 'local'; // default any localhost to local
    }

    // Fallback to prod for unknown hosts
    return 'prod';
};

const getRedirectUri = () => {
    // If explicit env var is set, use it
    if (process.env.VUE_APP_MSAL_REDIRECT_URI) {
        return process.env.VUE_APP_MSAL_REDIRECT_URI;
    }
    // If running on localhost and no env var, force trailing slash
    // Azure AD commonly registers localhost with a trailing slash
    if (globalThis.location.hostname === 'localhost' || globalThis.location.hostname === '127.0.0.1') {
        return globalThis.location.origin.endsWith('/') ? globalThis.location.origin : globalThis.location.origin + '/';
    }
    console.log('globalThis.location.origin;', globalThis.location.origin)
    return globalThis.location.origin;
}

/**
 * Get auth config based on environment
 */
const getAuthConfig = () => {
    const env = getEnvironment();

    if (env === 'local') {
        return {
            clientId: 'cd589853-e246-4124-a2cc-3b3bb299db78',
            authority: 'https://login.microsoftonline.com/5a8c21e3-7c52-40e3-8d81-deba37efd8dc',
            redirectUri: getRedirectUri(),
            postLogoutRedirectUri: process.env.VUE_APP_MSAL_POST_LOGOUT_REDIRECT_URI || (globalThis.location.origin + '/login'),
            navigateToLoginRequestUrl: process.env.VUE_APP_MSAL_NAVIGATE_TO_LOGIN_REQUEST_URL === 'true',
        };
    }

    // prod & stg use the same auth config
    return {
        clientId: process.env.VUE_APP_MSAL_CLIENT_ID || 'cd589853-e246-4124-a2cc-3b3bb299db78',
        authority: process.env.VUE_APP_MSAL_AUTHORITY || 'https://login.microsoftonline.com/5a8c21e3-7c52-40e3-8d81-deba37efd8dc',
        redirectUri: getRedirectUri(),
        postLogoutRedirectUri: process.env.VUE_APP_MSAL_POST_LOGOUT_REDIRECT_URI || (globalThis.location.origin + '/login'),
        navigateToLoginRequestUrl: process.env.VUE_APP_MSAL_NAVIGATE_TO_LOGIN_REQUEST_URL === 'true',
    };
};

/**
 * Get scopes based on environment
 * - prod  → newmy-prod scope
 * - stg   → newmy-dev scope
 * - local → .default scope
 */
export const getMsalScopes = () => {
    const env = getEnvironment();

    if (env === 'prod') {
        return ["api://cd589853-e246-4124-a2cc-3b3bb299db78/newmy-prod"];
    }
    if (env === 'stg') {
        return ["api://7be77e17-8065-4e8c-b2b0-25b937e0a627/newmy-locale"];
    }
    // local
    return ["api://cd589853-e246-4124-a2cc-3b3bb299db78/newmy-prod"];
};

export const msalConfig = {
    auth: getAuthConfig(),
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        allowNativeBroker: false,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return
                switch (level) {
                    case LogLevel.Error:
                        console.error('[MSAL]', message)
                        break
                    case LogLevel.Warning:
                        console.warn('[MSAL]', message)
                        break
                    case LogLevel.Info:
                        console.info('[MSAL]', message)
                        break
                    case LogLevel.Verbose:
                        console.debug('[MSAL]', message)
                        break
                }
            },
            logLevel: LogLevel.Warning,
            piiLoggingEnabled: false,
        },
    },
}
